export const cards = [
    {
        icon:  'event_note',
        title: `Data\nAvailability`,
        type: 'Data Availability',
        img: 'imgs/data.png',
        id: 1,
        subtitle: `Data Availability Dashboard: \nAn information management UI\n focused on providing the status \nof current/historical data loading.`
    },
    {
        icon: 'event_available',
        title: `Events`,
        type: 'Events',
        img: `imgs/events.png`,
        id: 2,
        subtitle: `Discover upcoming\n events, webinars, and\n latest insight trends`
    },
    {
        icon: 'date_range',
        title: `Knowledge\nHub`,
        type: 'Knowledge Hub',
        img: `imgs/hub.png`,
        id: 3,
        subtitle: `RSI's centralized\n searchable resource\n repository`
    }
];